import { Divider, DividerProps } from '@mui/material';
import React from 'react';

const PmiDivider = (props: DividerProps): React.ReactElement => {
  return (
    <Divider
      {...props}
      sx={{
        border: '1.5px solid black',
      }}
    />
  );
};

PmiDivider.displayName = 'PmiDivider Component';

export default PmiDivider;
